export const getCookie = (cookieName: string): string | null => {
    const name = cookieName + "=";
    const cookieParts = document.cookie.split(";");
    for (let i = 0; i < cookieParts.length; i++) {
        let cookiePart = cookieParts[i];
        while (cookiePart.charAt(0) === " ") {
            cookiePart = cookiePart.substring(1, cookiePart.length);
        }
        if (cookiePart.indexOf(name) === 0) {
            return cookiePart.substring(name.length, cookiePart.length);
        }
    }
    return null;
};
